'use strict'

/* -----------------------------------------------------------------------------
 * dependencies
 * -------------------------------------------------------------------------- */

// 3rd party
import React from 'react'
import moment from 'moment'

// lib
import Box, { BoxProps } from '@components/kit/box'
import Text from '@components/kit/text'
import { accessibilityLabel } from '@components/kit/_support'
import { titleCase } from '@utils/string-formatters'
import { Severity, SymptomDayLog } from './symptom-log-history-types'
import { colors } from '@theme'

/* -----------------------------------------------------------------------------
 * SymptomLogHistoryDay
 * -------------------------------------------------------------------------- */

const severityColorMap: Record<Severity, keyof typeof colors> = {
  [Severity.NONE]: 'transparent',
  [Severity.MILD]: 'paleYellow',
  [Severity.MODERATE]: 'paleOrange',
  [Severity.SEVERE]: 'paleRed'
}

type SymptomLogHistoryDayProps = BoxProps & {
  date: moment.Moment
  logs: SymptomDayLog[]
}

const SymptomLogHistoryDay = ({
  date,
  logs,
  ...rest
}: SymptomLogHistoryDayProps) => {
  return (
    <Box px='24' py='24' {...rest}>
      <Text
        variant='h3'
        mb='16'
        {...accessibilityLabel('Symptom Log History Day')}
      >
        {date.format('MMMM D')}
      </Text>
      {logs.map(log => (
        <Box
          key={log.symptom}
          flexDirection='row'
          justifyContent='space-between'
          alignItems='center'
          mb='08'
        >
          <Text
            textColor='purple'
            {...accessibilityLabel('Symptom Log History Symptom')}
          >
            {log.symptom}
          </Text>
          <Text
            variant='title'
            textColor={severityColorMap[log.severity]}
            {...accessibilityLabel('Symptom Log History Severity')}
          >
            {titleCase(Severity[log.severity])}
          </Text>
        </Box>
      ))}
    </Box>
  )
}

export default SymptomLogHistoryDay
